export { default } from "./ExpandableContent";
